import React from 'react';

import Panel from '../../../../../components/outline/Panel';
import Table from '../../../../../components/table/Table';
import columns from './columns';

const ProductNoticeInfo = ({ initialValue }) => {
  const { list = [] } = initialValue;

  return (
    <Panel className="brand-notice-product-list">
      <div className="panel-header">
        <div className="title">상품별 공지사항 관리</div>
      </div>

      <div className="panel-body">
        <Table
          data={list}
          isStriped={true}
          emptyText="등록된 상품 공지사항이 없습니다."
          showPagination={false}
          columns={(utils) =>
            columns({
              list,
              ...utils,
            })
          }
        />
      </div>
    </Panel>
  );
};

export default ProductNoticeInfo;
